<img class="repo_img" [src]="srcPath"
  [width]="32"
  [height]="32" />
<div class="repo_title">{{title}}</div>
